const styles = theme => ({
  fixedButtonContainer: {
    padding: '6px',
    width: '56px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '12px',
    position: 'fixed',
    right: '20px',
    top: '50%',
    transform: 'translateY(-50%)',
    alignıtems: 'flex-end',
    zIndex: 1000,
    backgroundColor: '#F4F6F8',
    gap: '12px',
  },

  fixedButton: {
    display: 'flex',
    gap: '6px',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '8px',
    width: '44px !important',
    height: '56px !important',
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: 'white',
    },
  },
  active: {
    cursor: 'pointer',
    backgroundColor: 'white',
  },
  iconContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    color: '#002E47',
  },
  label: {
    fontSize: '11px',
    fontWeight: '400',
  },

  optionsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: '12px',
  },
  dropdownContainer: {
    position: 'fixed',
    right: '91px',
    top: '50%',
    padding: '0px 12px 12px 12px',
    width: '208px',
    height: '648px',
    backgroundColor: '#F4F6F8',
    transform: 'translateY(-50%)',
    borderRadius: '12px',
    zIndex: 1101,
    color: '#002E47',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    overflow: 'hidden',
    '&:hover': {
      overflow: 'auto',
      overflowY: 'scroll',
      overflowX: 'hidden',
    },
    '&::-webkit-scrollbar': {
      width: '4px',
    },
    '&::-webkit-scrollbar-track': {
      background: '#F4F6F8',
      borderRadius: '4px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#CBD5E0',
      borderRadius: '4px',
      '&:hover': {
        background: '#A0AEC0',
      },
    },
    '&::-webkit-scrollbar-track-piece:start': {
      backgroundColor: 'transparent', // Make top transparent
      marginTop: '16px',
    },
    '&::-webkit-scrollbar-track-piece:end': {
      backgroundColor: 'transparent', // Make bottom transparent
      marginBottom: '16px',
    },
  },
  CKEditor: {
    width: '100%',
    height: 'auto',
    textAlign: 'center',
    margin: '0 auto',
  },
  dropdownHeader: {
    paddingTop: '12px',
    paddingBottom: '4px',
    width: '186px',
    position: 'sticky',
    top: '0',
    zIndex: '1' /* Ensure the header is on top of the content */,
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor: '#F4F6F8',
    alignItems: 'center',
  },

  iconButton: {
    width: '16px',
    minWidth: '16px',
    height: '16px',
  },
  icon: {
    cursor: 'pointer',
  },

  optionEmbedContainer: {
    width: '88px',
    height: '88px',
    cursor: 'pointer',
    borderRadius: '6px',
    border: '1px solid white',
    backgroundColor: 'white',
    '&:hover': {
      border: '1px solid #015FFB',
    },
  },

  optionContainer: {
    width: '186px',
    height: '92px',
    cursor: 'pointer',
    borderRadius: '6px',
    border: '1px solid white',
    backgroundColor: 'white',
    '&:hover': {
      border: '1px solid #015FFB',
    },
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
    marginBottom: '6px',
  },
  containerEmbed: {
    display: 'grid',
    gap: '6px',
  },

  optionTitle: {
    fontWeight: 400,
    fontSize: '10px',
    textAlign: 'center',
    width: '184px',
  },
  optionTitleEmbed: {
    fontWeight: 400, // Regular weight
    fontSize: '10px',
    textAlign: 'center',
  },

  optionHeading: {
    fontSize: '12px',
    color: 'rgba(0, 0, 0, 0.7)',
    marginBottom: '4px',
  },

  image: {
    width: '184px',
    height: '90px',
  },
  imageEmbed: {
    width: '86px',
    height: '86px',
  },
})

export default styles
